/*
 * The Private License
 *
 * Copyright (c) 2023 Mahon Media LLC.
 */

import React, { createContext, useContext, useState } from "react";

const CustomersContext = createContext();

export function CustomersProvider({ children }) {
  const [customers, setCustomers] = useState([]);

  return (
    <CustomersContext.Provider
      value={{ customers, setCustomers }}
    >
      {children}
    </CustomersContext.Provider>
  );
}

export const useCustomers = () => useContext(CustomersContext);
